import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "./Tim.css";

const Tim = () => {
    return (
        <div>
            <Container>
                <h1>Tim</h1>
                <Row>
                    <Col>
                        <p>
                            Timothy Paul Hogins is a believer and a doer. Timothy Paul Hogins is an African businessman, entrepreneur, investor and philanthropist. Tim is a Dreamer. Tim is a Visualiser. Tim is a Materialiser.
                        </p>
                        <p>
                            He is the Chairman and CEO of Hogins Enterprises (A diverse group of companies) and he is considered one of Africa’s emerging business leaders, with interests in Recreational Lifestyle brands, Technology, Manufacturing, E-commerce development, Real Estate & Property development, Pharmaceuticals, Health and Insurance.
                        </p>
                        <p>
                            Tim has been passionate about empowering the young and upcoming entrepreneur and grow the next leaders in the business world, for over ten years. His footprint shows an astute mind that seeks the most profitable and rewarding enterprise which enriches the community it’s founded and beyond. The following portfolio will demonstrate his drive more clearly.
                        </p>
                    </Col>
                </Row>

                <Row>
                    <Col className="grey" lg="8">
                        <h3>GREEN OUTDOOR GYMS (GOG)</h3>
                        <p>https://gog.co.za/gog/</p>
                        <p>GOG is undoubtedly Africa’s first and foremost outdoor Health and Wellness Company. At GOG, we believe that health and fitness is a right – not the luxury of a privileged few. GOG is the leading brand in outdoor health & fitness products, services and lifestyle experiences empowering all people of South Africa. Because of its success in South Africa, GOG has expanded to GOG Mozambique.</p>
                        <p>Product portfolio includes:</p>
                        <ul>
                            <li>Manufacturing (steel and plastic equipment)</li>
                            <li>Civil & Construction (CIDB 7)</li>
                            <li>Landscaping (CIDB 6 PE)</li>
                            <li>Outdoor Gym Facilities</li>
                            <li>Healthy Lifestyle Programs</li>
                        </ul>

                    </Col>
                    <Col className="projectimg grey" lg="4">
                        <img src="/assets/images/tim_01.png" />
                    </Col>


                    <Col className="clear" lg="8">
                        <h3>SIQALO DIGITAL, YKNOT SIQALO DIGITAL</h3>
                        <p>http://www.siqalodigital.co.za/</p>
                        <p>Siqalo Digital Solutions are and an accredited multi-vendor partner specializing in the design, Digital space, supply, installation and IT Support for businesses. We provide scalable, yet cost-effective and integrated IT solutions that leave you free to concentrate on your core business activities.</p>
                        <p>Product portfolio includes:</p>
                        <ul>
                            <li>Software Development</li>
                            <li>Interactive Digital solutions</li>
                            <li>Blockchain Development</li>
                            <li>Training platform</li>
                        </ul>

                    </Col>
                    <Col className="projectimg" lg="4">
                        <img src="/assets/images/tim_02.png" />
                    </Col>

                    <Col className="grey" lg="8">
                        <h3>BLACQMARKET </h3>
                        <p>https://blacqmarket.co.za/</p>
                        <p>
                            Blacqmarket is the leading ecommerce community that serves to bring to the fore the best that Africa has to showcase in any given industry. Securely backed with cryptocurrency it ensures a safe and profitable environment that encourages more interaction between liked minded individuals. It’s a way of life.
                        </p>
                        <ul>
                            <li>E-Commerce (Blockchain based platform)</li>

                        </ul>

                    </Col>
                    <Col className="projectimg grey" lg="4">
                        <img src="/assets/images/tim_03.png" />
                    </Col>

                    <Col className="clear"  lg="8">
                        <h3>HAPPY ISLAND</h3>
                        <p>www.happy-island.co.za</p>
                        <p>
                            The biggest ultimate water recreational theme park in Africa features the most incredible fun filled adventures. Some of the most exhilarating slides and relaxing pools, we have it all here at Happy Island Waterworld. It’s a destination of fun and adventure for some of the most incredible rides:
                        </p>
                        <ul>
                            <li>The Biggest Wave Pool in Africa</li>
                            <li>Gravity Loop</li>
                            <li>Lazy River</li>
                            <li>High Speed Slide</li>
                            <li>Behemoth Bowl</li>
                            <li>Master Blaster Super Tubes</li>
                            <li>Typhoon</li>
                            <li>Rainbow Slide</li>
                            <li>Massage Pools</li>
                            <li>Pirate Boat Slide</li>
                        </ul>

                    </Col>
                    <Col className="projectimg " lg="4">
                        <img src="/assets/images/tim_04.jpg" />
                    </Col>

                    <Col className="grey" lg="8">
                        <h3>GOG LIFESTYLE PARKS</h3>
                        <p>https://gog.co.za/lifestyle-parks/</p>
                        <p>
                            GOG Gardens Soweto is a multi-purpose entertainment, conferencing and outdoor playground. Among the many attractions at the park, there are water slides, pools, kiddie’s playground, a spray parks, picnic areas, conferencing facilities, market venues, accommodation and the concert/music facilities. Come for the time of your life.
                        </p>
                     

                    </Col>
                    <Col className="projectimg grey" lg="4">
                        <img src="/assets/images/tim_05.jpg" />
                    </Col>

                    <Col className="clear" lg="8">
                        <h3>REAL ESTATE</h3>
                       <p>
                           Real Estate development is key to the uplifting of the disadvantaged and the establishment of a Real Estate development SBU. Its biggest project to date is the development of the GOG Private Memorial Parks. Serving a niche need of decent memorial parks that serve a more diverse clientele base, the GOG Private Memorial Parks will be a ground breaking offering that will be one of the largest in South Africa.
                       </p>
                       
                    </Col>
                    <Col className="projectimg clear" lg="4">
                        <img src="/assets/images/tim_06.jpg" />
                    </Col>

                    <Col className="grey" lg="8">
                        <h3>PHARMACEUTICALS</h3>
                     <p>
                     The supply of good affordable pharmaceutical supplies was the driving force to setup UniHealth Freedom (Mozambique). With a dedicated supply chain that delivers more variety and affordability to the Mozambique Government.
                     </p>

                    </Col>
                    <Col className="projectimg grey" lg="4">
                        <img src="/assets/images/tim_07.jpg" />
                    </Col>

                    <Col className="clear"  lg="8">
                        <h3>INSURANCE</h3>
                     <p>
                     Short term insurance refers to insurance for the possessions that an individual owns, and is usually taken out for your home, the contents in your home, and car. It is important to insure your property and household goods from loss or damage. With this the following were setup to disrupt this industry sector with innovative solutions to meet a growing need. Mavericks Insurance SA and Freedom Holdings (Mozambique)
                     </p>

                    </Col>
                    <Col className="projectimg" lg="4">
                        <img src="/assets/images/tim_08.jpg" />
                    </Col>

                </Row>
            </Container>
        </div>
    );
};

export default Tim;